import { X_PLANERA_ORGANIZATION_ID, DO_NOT_SEND_HEADER, X_PLANERA_WORKSPACE_ID } from 'state_management/threadedConstants';

import { sendRequest } from '../core';
import { OrganizationInfoResponse } from './responses';

export async function getUserOrganizationDetails(id: string) {
  return sendRequest<OrganizationInfoResponse>('GET', `/api/v1/organizations`, undefined, {
    [X_PLANERA_ORGANIZATION_ID]: DO_NOT_SEND_HEADER,
    [X_PLANERA_WORKSPACE_ID]: DO_NOT_SEND_HEADER
  });
}
